import React from 'react';
import PropTypes from 'prop-types';
import { BADGES } from 'config/badges';
import { BadgedListItem } from 'components/facility/BadgedListItem';

import './badgeList.scss';

// This component is currently used on facility pages
export function BadgeList({ facilityBadges, giftCardValue }) {
	return (
		<div className="badge-list">
			{facilityBadges.map(
				(badge) =>
					BADGES[badge] && (
						<BadgedListItem
							key={BADGES[badge].color}
							color={BADGES[badge].color}
							icon={BADGES[badge].icon}
							name={BADGES[badge].name}
							facilityMessage={
								badge == 'giftcard'
									? BADGES[badge].facilityMessage(giftCardValue)
									: BADGES[badge].facilityMessage
							}
							tooltipMessage={
								badge == 'giftcard'
									? BADGES[badge].tooltipMessage(giftCardValue)
									: BADGES[badge].tooltipMessage
							}
						/>
					)
			)}
		</div>
	);
}
BadgeList.propTypes = {
	facilityBadges: PropTypes.arrayOf(PropTypes.string),
	giftCardValue: PropTypes.string,
};

export default BadgeList;
